// i18n area 'hci' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.fi-FI.meta.json.
import type { enUS } from './hci'

export const fiFI: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-klusterit',
      createButton: 'Luo Ceph-klusteri',
      emptyTitle: 'Ei hallittuja Ceph-klustereita',
      emptyBody: 'TVirt jakelee ja omistaa Cephin jäsensolmuilla, hyperkonvergoituna VM-kuorman kanssa. Luo klusteri: ensimmäinen monitor ja sen manager syntyvät automaattisesti valitulle ohjaussolmulle — kasvata sitä sitten lisämonitoreilla ja OSD-laitteilla.',
      pageTitle: 'Ceph-klusterit',
      colState: 'Tila',
      colMembers: 'Jäsenet',
      colSize: 'Koko',
      colVersion: 'Ceph-versio',
      sizeCell: '{used} GiB käytössä, yhteensä {total} GiB',
      phase: {
        'not-deployed': 'Ei deployattu',
        deploying: 'Deploy käynnissä',
        healthy: 'Kunnossa',
        degraded: 'Degradoitunut',
        error: 'Virhe',
        destroying: 'Tuhoutuu',
        destroyed: 'Tuhottu'
      },
      health: {
        HEALTH_OK: 'Kunnossa (HEALTH_OK)',
        HEALTH_WARN: 'Varoituksia (HEALTH_WARN)',
        HEALTH_ERR: 'Virhetilassa (HEALTH_ERR)',
        unknown: 'Ei vielä havaittu',
        observedAt: 'havaittu {time}'
      },
      create: {
        title: 'Luo Ceph-klusteri',
        info: 'Uutta Ceph-klusteria luotaessa valitaan ensimmäinen solmu, jolle MON- ja MGR-roolit asennetaan. Lisäksi määritetään, mitä subnetiä Ceph-liikenne käyttää: public-subnetiä käytetään yleiseen verkkoliikenteeseen, kun taas klusterisubnetiä käytetään OSD:iden välisiin sisäisiin replikoihin; eri subnetit eivät ole pakollisia.',
        controlNode: 'Ohjaussolmu',
        controlNodeHint: 'Jäsensolmu, jolle ensimmäinen MON + MGR syntyy.',
        publicSubnet: 'Public-subnet',
        publicSubnetHint: 'IPAMiin rekisteröity subnet — Cephin public_network. Muuttumaton luonnin jälkeen.',
        clusterSubnet: 'Klusterisubnet',
        clusterSubnetHint: 'IPAMiin rekisteröity subnet — Cephin cluster_network (replika/backfill).',
        noSubnets: 'Ei rekisteröityjä subnettejä — luo ne ensin IPAMissa',
        sameSubnet: 'Sama subnet public- ja klusteriliikenteelle',
        sameSubnetHint: 'Valittuna = klusteriverkko (replika/backfill) on sama kuin public. Ei valittuna = valitse sille oma subnet JA ohjaussolmun osoite sen sisältä.',
        controlAddress: 'Ohjaussolmun osoite',
        controlAddressHint: 'Osoite, jonka IPAM tuntee solmulle public-subnetin sisällä.',
        controlClusterAddress: 'Ohjaussolmun klusteriosoite',
        controlClusterAddressHint: 'Osoite, jonka IPAM tuntee solmulle klusterisubnetin sisällä.',
        noAddresses: 'IPAM ei tunne tälle solmulle osoitteita valitun subnetin sisällä',
        started: 'Klusteri luotu — bootstrap jatkuu macrotaskina; vaihe päivittyy itsestään',
        error: 'Klusteri hylättiin'
      },
      detail: {
        actions: 'Käytettävissä olevat toiminnot',
        tabOverview: 'Yleiskatsaus',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Poolit',
        tabObjects: 'Objektit',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Lisäasetukset',
        phase: 'Vaihe',
        checksTitle: 'Aktiiviset health-checkit',
        noChecks: 'Ei aktiivisia health-checkejä',
        checkMuted: 'vaimennettu',
        summaryPools: 'Poolit',
        summaryFilesystems: 'Tiedostojärjestelmät',
        nodesCard: 'Solmut',
        monHint: 'MGR toimii jokaisen MONin rinnalla samalla solmulla. Kolme MONia on suositeltu quorum; laboratorioklusteri aloittaa yhdellä. OSD:t ja MDS:t elävät omilla välilehdillään.',
        monHintSplit: 'MON ja MGR ovat erilliset tällä klusterilla (Lisäasetukset): kumpikin rooli on oma membershipinsä solmua kohden. Kolme MONia on suositeltu quorum; vähintään yhden MGR:n on oltava olemassa.',
        noMons: 'Ei deklaroituja monitoreita',
        addNode: 'Lisää solmu',
        removeNode: 'Poista solmu',
        removeNodeFrom: 'Poista solmu {node} (sen MON ja rinnalla toimiva MGR)',
        roleMon: 'MON-rooli',
        roleMgr: 'MGR-rooli',
        roleNa: 'N/A',
        roleNotObserved: 'ei vielä havaittu',
        monInQuorum: 'quorumissa',
        monOutQuorum: 'quorumin ulkopuolella',
        mgrActive: 'aktiivinen',
        mgrStandby: 'standby',
        addRoleMon: 'Lisää MON-rooli',
        removeRoleMon: 'Poista MON-rooli',
        addRoleMgr: 'Lisää MGR-rooli',
        removeRoleMgr: 'Poista MGR-rooli',
        restartMon: 'Käynnistä MON-palvelu uudelleen',
        restartMgr: 'Käynnistä MGR-palvelu uudelleen',
        addMon: 'Lisää MON',
        removeMon: 'Poista MON',
        removeMonFrom: 'Poista MON-rooli solmulta {node}',
        addMgr: 'Lisää MGR',
        removeMgr: 'Poista MGR',
        removeMgrFrom: 'Poista MGR-rooli solmulta {node}',
        addMds: 'Lisää MDS',
        removeMds: 'Poista MDS',
        removeMdsFrom: 'Poista MDS-rooli solmulta {node}',
        mdsSection: 'Metadata-palvelin (MDS)',
        noMds: 'Ei deklaroituja MDS-daemoneita — tiedostojärjestelmä vaatii ensin yhden',
        mdsHint: 'MDS-membership on oma ensimmäisestä päivästä lähtien: klusteri ilman CephFS:ää ei deklaroi yhtään, yksi aktiivinen plus yksi standby palvelevat tiedostojärjestelmää hyvin. Ceph valitsee aktiiviset ja standbyt deklaroitujen daemonien joukosta.',
        mdsActiveFor: 'aktiivinen — {fs}',
        mdsNotObserved: 'ei vielä havaittu',
        lastMdsGuard: 'Viimeistä MDS:ää ei voi poistaa niin kauan kuin tiedostojärjestelmä on olemassa — poista ensin tiedostojärjestelmät',
        lastMonGuard: 'Viimeistä MONia ei voi poistaa — klusterin tuhoaminen on ainoa ulospääsy',
        lastMgrGuard: 'Viimeistä MGR:ää ei voi poistaa — hallittu klusteri ei koskaan toimi ilman manageria',
        registerDevice: 'Lisää OSD',
        unregisterDevice: 'Poista rekisteristä',
        activeDeviceGuard: 'Aktiivinen OSD — se poistuu OSD-elinkaaren kautta, ei rekisteristä',
        colNode: 'Solmu',
        devicePhase: { registered: 'Rekisteröity', active: 'Aktiivinen' },
        health: 'Terveys',
        state: 'Tila',
        fsid: 'fsid',
        fsidPending: 'puuttuu — yritä bootstrapia uudelleen',
        version: 'Ceph-versio',
        publicNetwork: 'Public-verkko',
        clusterNetwork: 'Klusteriverkko',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ei käytettävissä olevia toimintoja tässä vaiheessa',
        destroyedNote: 'Klusteri tuhottu — rivi poistuu automaattisesti hetken kuluttua'
      },
      overview: {
        services: 'Palvelut',
        ok: 'kunnossa',
        warning: 'warning',
        down: 'alhaalla',
        pgTitle: 'PG-tilat',
        pgTotal: '{n} PG:tä yhteensä',
        capacityTitle: 'Tallennustila',
        ioTitle: 'Nykyinen I/O',
        ioReadBw: 'Lukukaista',
        ioWriteBw: 'Kirjoituskaista',
        ioReadIops: 'Luku-IOPS',
        ioWriteIops: 'Kirjoitus-IOPS',
        notObserved: 'ei vielä havaittu'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Tila',
        colSize: 'Koko',
        colPgs: 'PG',
        empty: 'Ei OSD:itä — lisää sellainen deklaroidusta datalevystä',
        markIn: 'Merkitse IN',
        markOut: 'Merkitse OUT',
        scrub: 'Suorita scrub',
        deepScrub: 'Suorita syvä scrub',
        restart: 'Käynnistä palvelu uudelleen',
        details: 'Tiedot',
        actionGuard: 'Vain deployatun klusterin aktiivisella OSD:llä',
        inTitle: 'Merkitse OSD IN',
        inBody: 'osd.{id} palaa datan jakeluun (ceph osd in): Ceph tasapainottaa dataa sille uudelleen.',
        outTitle: 'Merkitse OSD OUT',
        outBody: 'osd.{id} poistuu datan jakelusta (ceph osd out): sen data tasapainottuu muualle ja redundanssi on ALENTUNUT niin kauan kuin backfill on käynnissä. Peruttavissa milloin tahansa toiminnolla Merkitse IN.',
        scrubTitle: 'Ajoita scrub',
        scrubBody: 'osd.{id}:lle ajoitetaan scrub: mon lisää sen jonoon ja seuraavien sweepien PG-tilat kertovat lopputuloksen.',
        deepScrubTitle: 'Ajoita syvä scrub',
        deepScrubBody: 'osd.{id}:lle ajoitetaan syvä scrub: variantti, joka tarkistaa tavut — raskaampi I/O:lle, sama mekaniikka.',
        restartTitle: 'Käynnistä OSD-palvelu uudelleen',
        restartBody: 'osd.{id} pysäytetään ja käynnistetään uudelleen workerin valvonnan kautta sen solmulla.',
        started: 'Toiminto käynnistetty — havainto päivittyy itsestään',
        error: 'OSD-toiminto hylättiin'
      },
      osdDetail: {
        title: 'OSD:n tiedot',
        tabGeneral: 'Yleiset',
        tabNetwork: 'Verkko',
        tabDevices: 'Laitteet',
        version: 'Versio',
        hostname: 'Hostname',
        dataPath: 'OSD:n datapolku',
        objectStore: 'OSD:n object store',
        encrypted: 'Salattu',
        yes: 'Kyllä',
        no: 'Ei',
        memory: 'Muistinkäyttö (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-osoite (client & monitor)',
        hbFront: 'Heartbeat front -osoite',
        back: 'Back-osoite (OSD)',
        hbBack: 'Heartbeat back -osoite',
        colDevice: 'Device',
        colType: 'Tyyppi',
        colPhysical: 'Fyysinen device',
        colSize: 'Koko',
        volumeTitle: 'Volyymin tiedot',
        creationTime: 'Luontiaika',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ei havaittuja devicejä tälle OSD:lle'
      },
      restart: {
        title: 'Käynnistä palvelu uudelleen',
        monBody: 'MON-daemon solmulla {node} pysäytetään ja käynnistetään uudelleen workerin valvonnan kautta.',
        mgrBody: 'MGR-daemon solmulla {node} pysäytetään ja käynnistetään uudelleen workerin valvonnan kautta.',
        started: 'Uudelleenkäynnistys aloitettu — havainto päivittyy itsestään',
        error: 'Uudelleenkäynnistys hylättiin'
      },
      encryptionMode: {
        alwaysOn: 'Aina käytössä (dmcrypt)',
        alwaysOff: 'Aina pois käytöstä',
        perOsd: 'Valitaan jokaiselle OSD:lle erikseen',
        section: 'OSD-salaus at rest',
        title: 'Vaihda OSD-salaustilaa',
        hint: 'Miten UUDET OSD:t valmistellaan. Olemassa olevat OSD:t pitävät levykohtaisen tilansa: sen vaihtamiseksi OSD poistetaan ja luodaan uudelleen.',
        body: 'Tilaksi tulee "{mode}" ja se koskee VAIN UUSIA OSD:itä: jokainen olemassa oleva OSD pitää nykyisen salaustilansa.',
        apply: 'Vaihda tila',
        error: 'Tilan vaihto hylättiin'
      },
      pin: {
        address: 'Public-osoite (valinnainen pin)',
        clusterAddress: 'Klusteriosoite (valinnainen pin)',
        autoPlaceholder: 'automaattinen subnetissä {cidr}',
        hint: 'Daemon-kohtainen osoitteistus: tyhjä = Ceph kiinnittyy itse deklaroidun verkon sisällä; täytetty = tämä instanssi pinnataan osoitteeseen omassa conf-osiossaan.'
      },
      addMon: {
        title: 'Lisää solmu',
        node: 'Solmu',
        address: 'Public-osoite',
        addressHint: 'Solmun osoitteet, jotka IPAM tuntee public-subnetin sisällä — automaattinen, kun olemassa oleva deklaraatio kattaa solmun.',
        clusterAddress: 'Klusteriosoite',
        clusterAddressHint: 'Pakollinen: klusterisubnet on erillinen eikä solmua ole vielä deklaroitu siihen.',
        noAddresses: 'IPAM ei tunne tälle solmulle osoitteita subnetin sisällä',
        error: 'Monin lisäys hylättiin'
      },
      removeMon: {
        title: 'Poista MON',
        body: 'MON ja sen rinnalla toimiva MGR jättävät solmun {node}. Deployatulla klusterilla daemonit pysäytetään ja poistetaan quorumista.',
        error: 'MONin poisto hylättiin'
      },
      addMgr: {
        title: 'Lisää MGR',
        node: 'Solmu',
        hint: 'Lisäasetukset (erilliset MON/MGR): standalone-manager syntyy valitulle jäsensolmulle solmuun sidotulla taskilla. Cephin active/standby-vaali valitsee aktiivisen MGR:n itse.',
        error: 'MGR:n lisäys hylättiin'
      },
      removeMgr: {
        title: 'Poista MGR',
        body: 'Standalone-MGR jättää solmun {node}. Deployatulla klusterilla daemon pysäytetään ja sen tila poistetaan; solmun MONiin (jos sellainen on) ei kosketa.',
        error: 'MGR:n poisto hylättiin'
      },
      addMds: {
        title: 'Lisää MDS',
        node: 'Solmu',
        hint: 'CephFS:n metadata-palvelin: syntyy valitulle jäsensolmulle solmuun sidotulla taskilla, workerin valvomana kuten MON ja MGR. Ceph valitsee aktiiviset ja standbyt itse — yksi aktiivinen plus yksi standby palvelevat tiedostojärjestelmää hyvin.',
        error: 'MDS:n lisäys hylättiin'
      },
      removeMds: {
        title: 'Poista MDS',
        body: 'MDS jättää solmun {node}. Deployatulla klusterilla daemon pysäytetään ja sen tila poistetaan; API hylkää viimeisen MDS:n poiston niin kauan kuin tiedostojärjestelmä tarvitsee sitä.',
        error: 'MDS:n poisto hylättiin'
      },
      split: {
        title: 'Erilliset MON/MGR',
        label: 'Salli MON ja MGR eri solmuilla',
        hint: 'Pois päältä (oletus) = ratifioitu standardi: MGR toimii jokaisen MONin rinnalla, yksi ainoa membership. Päällä = MGR:ien membership muuttuu omakseen, hallittavissa toiminnoilla Lisää/Poista MGR Hallintasolmut-välilehdellä.',
        enable: 'Ota käyttöön',
        disable: 'Poista käytöstä',
        enableBody: 'MGR:ien membership muuttuu riippumattomaksi MONeista, alustettuna nykyisestä sijoittelusta. Toiminnot Lisää/Poista MGR aktivoituvat Hallintasolmut-välilehdellä. Tämä löysentää alustan oletusta — pidä se vain, jos tiedät miksi tarvitset sitä.',
        disableBody: 'Paluu standardisijoitteluun: yksi MGR jokaisen MONin kanssa, yksi ainoa membership. Sallittu vain, jos MGR:ien membership vastaa jo MONeja — linjaa se ensin toiminnoilla Lisää/Poista MGR, tai API hylkää.',
        error: 'Muutos hylättiin'
      },
      rawEditor: {
        title: 'Raaka CRUSH-editori',
        label: 'Näytä crushmapin raakaeditori CRUSH-välilehdellä',
        hint: 'Pois päältä (oletus) = ohjattu sääntöpinta on standardityökalu. Päällä = CRUSH-välilehti näyttää myös dekompiloidun crushmapin muokattavana tekstinä. Tallennus vaatii aina sudon, klusterin nimen vahvistukseksi, ja kulkee crushtoolin compile + test -vaiheiden läpi ENNEN kuin se saavuttaa klusterin.'
      },
      osdFlags: {
        section: 'Globaalit OSD-flagit',
        title: 'OSD-flagien override',
        notObserved: 'ei vielä havaittu',
        standardFlowsHint: 'Alustan standardivirrat hallitsevat näitä flageja itse normaalitapauksissa (solmun huolto asettaa kohdistetun nooutin, levyn vaihto kulkee OSD-elinkaaren kautta). Tämä osio on manuaalinen override operaattorille, joka tietää mitä tekee.',
        notDeployedGuard: 'OSD-flagit ovat olemassa vain deployatulla klusterilla',
        set: 'Aseta flag',
        unset: 'Poista flag',
        setBody: 'Globaali flag {flag} ASETETAAN osdmapiin. Se pysyy, kunnes se poistetaan eksplisiittisesti — unohtunut flag heikentää klusterin itsekorjausta.',
        unsetBody: 'Globaali flag {flag} POISTETAAN osdmapista.',
        error: 'Flagin muutos hylättiin',
        flag: {
          noout: 'Yhtään OSD:tä ei merkitä out datan jakelusta — ei uudelleentasapainotusta daemonin menetyksen yhteydessä',
          norebalance: 'Datan uudelleentasapainotus on pysäytetty',
          nobackfill: 'Backfill on pysäytetty',
          norecover: 'Recovery on pysäytetty',
          pause: 'KAIKKI clientien I/O on tauolla (luku ja kirjoitus)',
          noin: 'Käynnistyviä OSD:itä ei merkitä in automaattisesti',
          nodown: 'Tavoittamattomia OSD:itä ei merkitä down — peittää todellisia vikoja'
        }
      },
      pools: {
        section: 'Poolit',
        create: 'Luo pool',
        createGuard: 'Poolit ovat olemassa vain deployatulla klusterilla',
        notObserved: 'Ei havaintoja pooleista — monin sweep raportoi tänne',
        empty: 'Ei pooleja klusterilla',
        colName: 'Nimi',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Sovellus',
        colRule: 'CRUSH-sääntö',
        colUsage: 'Käyttö',
        observedAtLabel: 'Havaittu',
        objects: '{n} objektia',
        inUseBy: 'käytössä — {name}',
        internalGuard: 'Cephin sisäinen pool — alusta ei koskaan poista sitä',
        delete: 'Poista pool',
        deleteGuard: 'Storagen {name} kuluttama — poista ensin storage',
        hint: 'Vain replikoidut poolit (erasure coding on v1-scopen ulkopuolella). Replikointi elää Cephissä: tämä taulukko on monin sweepin havaitsema totuus.',
        createTitle: 'Luo pool',
        createHint: 'Pool syntyy klusterille pyydetyllä replikoinnilla ja rbd-sovellus käytössä — työn tekee task MON-solmulla. Kytke "Ehdota storageksi" päälle kuluttaaksesi sen heti samalla eleellä.',
        name: 'Poolin nimi',
        nameHint: 'DNS-safe (pienet kirjaimet, numerot, viivat).',
        size: 'Replikat (size)',
        sizeHint: 'Kopiot jokaisesta objektista. Oletus 3.',
        minSize: 'Vähimmäisreplikat (min_size)',
        minSizeHint: 'Vähimmäiskopiot I/O:n palvelemiseen — seuraa arvoa size − 1, kunnes muutat sitä.',
        createError: 'Poolin luonti hylättiin',
        deleteTitle: 'Poista pool',
        deleteBody: 'Pool {pool} ja JOKAINEN objekti sen sisällä tuhotaan peruuttamattomasti. Kirjoita poolin nimi vahvistukseksi.',
        confirmLabel: 'Poolin nimi',
        confirmHint: 'Kirjoita poolin nimi vahvistukseksi',
        deleteError: 'Poolin poisto hylättiin',
        detailTitle: 'Poolin tiedot',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Käytössä',
        autoscalerOff: 'Ei käytössä',
        autoscalerWarn: 'Ilmoitus',
        pgNumLabel: 'PG-määrä',
        pgNumCaption: 'Havaittu: autoscaler voi muuttaa sitä itsenäisesti — tämä kenttä kirjoittaa toiveen.',
        storage: 'Liitetty TVirt-storage',
        addAsStorage: 'Lisää TVirt-storagena',
        ruleSudoHint: 'CRUSH-säännön vaihto vaatii operaattorin salasanan.',
        updateError: 'Poolin muutos hylättiin',
        updated: 'Poolin muutos käynnistetty — havainto päivittyy itsestään'
      },
      crush: {
        section: 'CRUSH-säännöt',
        notObserved: 'Ei vielä CRUSH-havaintoja — monin sweep raportoi tänne',
        empty: 'Ei havaittuja sääntöjä klusterilla',
        hint: 'Sääntö päättää, MINNE jokaisen objektin kopiot päätyvät — sen vikadomeeni on yksikkö, joka voi vikaantua ilman datan menetystä. Poolit osoittavat sääntöön; builtin replicated_rule (yksi replika per palvelin) on syntymäoletus.',
        create: 'Luo sääntö',
        createGuard: 'CRUSH-säännöt ovat olemassa vain deployatulla klusterilla',
        createTitle: 'Luo CRUSH-sääntö',
        createHint: 'Sääntö = vikadomeenin valinta. Sääntö syntyy replikoituna oletus-rootiin — työn tekee task MON-solmulla; liitä poolit Poolit-välilehdeltä jälkikäteen.',
        createError: 'Säännön luonti hylättiin',
        name: 'Säännön nimi',
        nameHint: 'DNS-safe (pienet kirjaimet, numerot, viivat).',
        domain: 'Vikadomeeni',
        domainChoice: {
          osd: 'Jokainen replika eri OSD:llä',
          host: 'Jokainen replika eri palvelimella',
          rack: 'Jokainen replika eri rackissa'
        },
        domainCustom: 'Mukautettu (käsin kirjoitetut stepit)',
        domainOther: 'Jokainen replika eri yksikössä tyyppiä {type}',
        rackGuardHint: 'Havaitussa hierarkiassa ei ole yhtään rack-buckettia: säännön voi silti luoda, mutta yksikään pool ei voi osoittaa siihen ennen kuin rack on deklaroitu jäsenpalvelinten sijoittelussa (solmun asetukset) — uudelleenlinjauksen tekevä task rakentaa bucketin ja liittäminen avautuu itsestään.',
        treeTitle: 'Havaittu hierarkia',
        treeNotObserved: 'Ei havaintoja hierarkiasta — monin sweep raportoi tänne',
        treeOsds: '{n} OSD:tä',
        treeHint: 'CRUSH-kartta klusterin näkemänä: root → deklaroidut tasot → palvelimet (host) → OSD:t. Topologia seuraa jokaisen palvelimen deklaroitua sijoittelua (solmun asetukset) — sijainnin muutos linjaa sen uudelleen taskin kautta.',
        unplacedWarning: 'Jäsenet ilman deklaroitua sijaintia: {nodes} — niiden hostit jäävät suoraan rootin alle, deklaroidun topologian ulkopuolelle. Deklaroi sijainti solmun asetuksissa (varoitus, ei koskaan este).',
        colName: 'Nimi',
        colDomain: 'Vikadomeeni',
        colPools: 'Poolit',
        builtinChip: 'builtin',
        builtinGuard: 'Klusterin oletussääntö — alusta ei koskaan poista sitä',
        detailAction: 'Säännön tiedot',
        detailType: 'Tyyppi',
        backToRules: 'Säännöt',
        ruleNotObserved: 'Havaittu sääntölista ei mainitse tätä sääntöä',
        noPools: 'Yksikään pool ei käytä tätä sääntöä',
        delete: 'Poista sääntö',
        deleteTitle: 'Poista CRUSH-sääntö',
        deleteBody: 'Sääntö {rule} poistetaan klusterin crushmapista. Yksikään pool ei saa käyttää sitä. Kirjoita säännön nimi vahvistukseksi.',
        deleteGuard: 'Pool {name} käyttää tätä — osoita pool ensin muualle',
        confirmLabel: 'Säännön nimi',
        confirmHint: 'Kirjoita säännön nimi vahvistukseksi',
        deleteError: 'Säännön poisto hylättiin',
        changeRule: 'Vaihda CRUSH-sääntö',
        changeRuleTitle: 'Vaihda CRUSH-sääntö',
        changeRuleHint: 'Pool alkaa sijoittaa objektejaan valitun säännön mukaan — Ceph siirtää olemassa olevan datan mukautuakseen (täydellä poolilla seuraa uudelleentasapainotus).',
        changeRuleError: 'Säännön vaihto hylättiin',
        rule: 'CRUSH-sääntö',
        rawTitle: 'Raaka crushmap (dekompiloitu)',
        rawWarning: 'VAARA: tämä teksti on klusterin KOKO sijoittelupolitiikka. Väärä kartta voi rikkoa kaikkien poolien placementin kerralla. Tallennus kääntää ja testaa kartan crushtoolilla ENNEN sen injektointia — mutta validi kartta voi silti olla huono idea.',
        rawReload: 'Lataa uudelleen',
        rawLoading: 'Kysely käynnissä — read-only-task dekompiloi crushmapia…',
        rawSave: 'Tallenna crushmap',
        rawSaveTitle: 'Injektoi crushmap',
        rawSaveBody: 'Muokattu teksti korvaa KOKO klusterin crushmapin crushtoolin compile + test -vaiheiden jälkeen. Kirjoita klusterin nimi vahvistukseksi.',
        rawConfirmLabel: 'Klusterin nimi',
        rawConfirmHint: 'Kirjoita {name} vahvistukseksi',
        rawError: 'Crushmap-operaatio epäonnistui',
        rawHint: 'Teksti on crushtool -d -muotoa. Käännös- ja testivirheet palaavat sanasta sanaan crushtoolilta — kartta ei saavuta klusteria, jos jompikumpi porteista epäonnistuu.'
      },
      objects: {
        poolsSection: 'Objektiselain',
        poolsHint: 'Valitse pool listataksesi sen RBD-levykuvat. Jokainen syvä luku toimii read-only-taskina MON-solmulla — se ei estä todellisia operaatioita (eivätkä ne estä sitä).',
        deployedGuard: 'Objektikyselyt vastaavat vain deployatulla klusterilla',
        browse: 'Selaa objekteja',
        detailAction: 'Levykuvan tiedot',
        backToPools: 'Poolit',
        backToImages: 'Levykuvat',
        refresh: 'Päivitä',
        loading: 'Kysely käynnissä — read-only-task kyselee klusterilta…',
        error: 'Kysely epäonnistui',
        retry: 'Yritä uudelleen',
        notRbd: 'Pool, jonka application on "{app}" — se ei sisällä RBD-levykuvia, ei mitään selattavaa täällä',
        noImages: 'Ei RBD-levykuvia tässä poolissa',
        colImage: 'Levykuva',
        colSize: 'Koko',
        colObjects: 'Objektit',
        colSnapshots: 'Snapshotit',
        imagesHint: 'Kuluttavan rbd-storagen levyt ovat levykuvia, joiden nimi on niiden levy-id. Objektimäärä on provisioned (koko / objektikoko) — todellinen käyttö elää levykuvan tiedoissa.',
        infoTitle: 'Levykuva',
        infoSize: 'Virtuaalinen koko',
        infoObjects: 'Objektit (provisioned)',
        infoObjectSize: 'Objektikoko',
        infoPrefix: 'Objektien etuliite',
        infoFormat: 'Formaatti',
        infoFeatures: 'Featuret',
        usageTitle: 'Todellinen käyttö (rbd du)',
        usageOf: '{provisioned} GiB:n provisioned-määrästä',
        usageHint: 'Luonnostaan thin: vain kirjoitetut objektit vievät tavuja.',
        watchersTitle: 'Watcherit',
        noWatchers: 'Ei watchereita — kenelläkään ei ole tätä levykuvaa auki juuri nyt',
        snapshotsTitle: 'RBD-snapshotit',
        noSnapshots: 'Ei RBD-snapshoteja tällä levykuvalla',
        colSnapshot: 'Snapshot',
        colProtected: 'Suojattu',
        colTimestamp: 'Luotu',
        protected: 'suojattu',
        mappingTitle: 'Fyysinen mappaus (OSD-joukko)',
        mappingSampled: 'Otos: {sampled} objektia kaikkiaan {total} objektista — rehellinen tiivistelmä: suurilla levykuvilla joukko konvergoi poolin KAIKKIIN OSD:ihin (CRUSH jakaa objektit koko poolin yli).',
        mappingComplete: 'Kaikki objektit mapattu ({total} / {total}).',
        objectQueryTitle: 'Mappaa yksittäinen objekti',
        objectName: 'Objektin nimi',
        objectHint: 'RADOS-objektinimet ovat muotoa <etuliite>.<16-hex-indeksi> — ceph osd map vastaa PG:llä ja OSD-kolmikoilla.',
        mapObject: 'Mappaa',
        primary: 'ensisijainen: osd.{osd}'
      },
      registerDevice: {
        title: 'Rekisteröi OSD-laite',
        hint: 'Elävällä klusterilla rekisteröinti myös VALMISTELEE laitteen: siitä tulee BlueStore-OSD automaattisella, solmuun sidotulla taskilla (ei koskaan tyhjä, ratifioitu 2026-07-24). Laite kuuluu korkeintaan yhteen Ceph-klusteriin koko laivastossa.',
        disk: 'Datalevy',
        diskHint: 'Solmun deklaroidut datalevyt — nimi ja sarjanumero',
        noDeclared: 'Ei deklaroituja datalevyjä tällä solmulla — merkitse ne ensin solmun paikallisissa asetuksissa',
        serialHint: 'Laitteen sarjanumero — identiteetin pin',
        encrypted: 'Salaa tämä OSD (dmcrypt)',
        encryptedHint: 'OSD-kohtainen valinta (klusterin tila on "valitaan jokaiselle OSD:lle erikseen"): se jäätyy tälle levylle rekisteröinnissä — myöhempi tilan vaihto ei koskaan kirjoita sitä uudelleen; sen tekee rivitoiminto salaa/pura salaus.',
        error: 'Rekisteröinti hylättiin'
      },
      unregisterDevice: {
        title: 'Poista laite rekisteristä',
        body: 'Vain rekisteri: {name} lakkaa olemasta tämän klusterin OSD-kandidaatti. Sen tavuihin ei kosketa.',
        error: 'Rekisteristä poisto hylättiin'
      },
      deploy: {
        action: 'Yritä deployta uudelleen',
        title: 'Yritä bootstrapia uudelleen',
        body: 'Alkuperäinen bootstrap käynnistyy uudelleen nykyisestä konfiguraatiosta: monit käynnistyvät, jokainen rekisteröity laite valmistellaan ja aktivoidaan BlueStore-OSD:nä. Operaatio toimii macrotaskina — vaihe päivittyy itsestään.',
        started: 'Bootstrap käynnistetty — jatkuu macrotaskina; vaihe päivittyy itsestään',
        error: 'Bootstrap hylättiin'
      },
      propose: {
        action: 'Ehdota storageksi',
        title: 'Ehdota storageksi',
        hintPool: 'Olemassa oleva pool {name} muuttuu TVirt-storageksi: pooliin rajattu cephx-identiteetti päätyy keystoreen ja ceph-rbd-storage syntyy valmiina. Ehdotus kuluttaa poolin — se ei koskaan luo uutta.',
        hintFs: 'Olemassa oleva tiedostojärjestelmä {name} muuttuu TVirt-storageksi: tiedostojärjestelmään rajattu cephx-identiteetti päätyy keystoreen ja cephfs-storage syntyy valmiina ja liitettynä. Ehdotus kuluttaa tiedostojärjestelmän — se ei koskaan luo uutta.',
        name: 'Storagen nimi',
        nameHint: 'DNS-1123, yksilöllinen scopessa — cephx-identiteetti saa nimensä siitä.',
        path: 'Path tiedostojärjestelmän sisällä',
        pathHint: 'Absoluuttinen path sen tiedostojärjestelmän sisällä, jonka storage liittää — / jos olet epävarma.',
        alsoPropose: 'Ehdota heti storageksi',
        alsoProposePoolHint: 'Luonnin jälkeen sama ele ehdottaa vastasyntyneen poolin ceph-rbd-storageksi — kaksi eksplisiittistä kutsua, yksi dialogi.',
        alsoProposeFsHint: 'Luonnin jälkeen sama ele ehdottaa vastasyntyneen tiedostojärjestelmän cephfs-storageksi — kaksi eksplisiittistä kutsua, yksi dialogi.',
        guard: 'Ehdota storageksi — vain healthy-klusterilla',
        started: 'Ehdotus hyväksytty — storage materialisoituu; löydät sen kohdasta Storage',
        submit: 'Luo storage',
        error: 'Ehdotus hylättiin'
      },
      fs: {
        section: 'Tiedostojärjestelmät',
        create: 'Luo tiedostojärjestelmä',
        createGuard: 'Tiedostojärjestelmät ovat olemassa vain deployatulla klusterilla',
        mdsFirstGuard: 'Lisää ensin MDS — tiedostojärjestelmä ilman metadata-palvelinta syntyy käyttökelvottomana',
        notObserved: 'Ei havaintoja tiedostojärjestelmistä — MONin sweep raportoi tänne',
        empty: 'Ei tiedostojärjestelmiä klusterilla',
        colName: 'Nimi',
        colPools: 'Poolit',
        colMds: 'MDS',
        noActiveMds: 'ei aktiivista MDS:ää',
        delete: 'Poista tiedostojärjestelmä',
        deleteGuard: 'Storagen {name} kuluttama — poista ensin storage',
        hint: 'Tiedostojärjestelmä omistaa data- ja metadata-poolinsa (cephfs.<nimi>.data / .meta): ne syntyvät sen kanssa ja kuolevat sen kanssa — removeFs, ei koskaan poolin käsin tehtyä deleteä. Tämä taulukko on MONin sweepin havaitsema totuus.',
        createTitle: 'Luo tiedostojärjestelmä',
        createHint: 'Tiedostojärjestelmä syntyy klusterille kahden poolinsa kanssa (application cephfs) ja sitä palvelevat deklaroidut MDS:t — työn tekee task MON-solmulla. Kytke "Ehdota storageksi" päälle kuluttaaksesi sen heti samalla eleellä.',
        name: 'Tiedostojärjestelmän nimi',
        nameHint: 'DNS-safe (pienet kirjaimet, numerot, viivat).',
        sizeHint: 'MOLEMPIEN syntyvien poolien replikat. Oletus 3.',
        createError: 'Tiedostojärjestelmän luonti hylättiin',
        deleteTitle: 'Poista tiedostojärjestelmä',
        deleteBody: 'Tiedostojärjestelmä {fs} ja JOKAINEN tiedosto sen sisällä tuhotaan peruuttamattomasti — sen data- ja metadata-poolit kuolevat sen mukana. Kirjoita tiedostojärjestelmän nimi vahvistukseksi.',
        confirmLabel: 'Tiedostojärjestelmän nimi',
        confirmHint: 'Kirjoita tiedostojärjestelmän nimi vahvistukseksi',
        deleteError: 'Tiedostojärjestelmän poisto hylättiin'
      },
      destroy: {
        action: 'Tuhoa',
        retryAction: 'Yritä tuhoamista uudelleen',
        retryGuard: 'Tuhoaminen on käynnissä — retry koskee epäonnistunutta tuhoamista (muuten lease hylkää)',
        title: 'Tuhoa klusteri',
        body: 'Deployattu fabric puretaan: tämän klusterin jokainen daemon pysähtyy, sen järjestelmätila ja keystoren avaimet vapautetaan. Onnistuneen tuhoamisen jälkeen klusteri poistetaan automaattisesti.',
        confirmLabel: 'Klusterin nimi',
        confirmHint: 'Kirjoita klusterin nimi vahvistukseksi',
        wipe: 'Tyhjennä rekisteröidyt laitteet',
        wipeHint: 'Valittuna: jokaisen rekisteröidyn laitteen allekirjoitukset pyyhitään — niiden päällä oleva data tuhoutuu. Ei valittuna: tavut säilyvät koskemattomina ja laitteet palaavat rekisteröidyiksi.',
        guard: 'Tuhoa — mitään ei ole deployattu',
        started: 'Tuhoaminen käynnistetty — jatkuu macrotaskina; vaihe päivittyy itsestään',
        error: 'Tuhoaminen hylättiin'
      },
      delete: {
        guard: 'Poista — vain konfiguraatio, jota ei ole deployattu (tuhoa ensin)',
        title: 'Poistetaanko {name}?',
        body: 'Konfiguraatio ja sen laiterekisteri poistetaan. Sallittu vain niin kauan kuin mitään ei ole deployattu.',
        error: 'Poisto hylättiin'
      }
    }
  }
}
